<template>
  <div>
    <page-table :data-api="this.api.coach" viewable keyField="uid">
      <el-table-column prop="id" label="编号" width="80">
      </el-table-column>
      <el-table-column prop="name" label="姓名">
      </el-table-column>
      <el-table-column prop="mobile" label="手机">
      </el-table-column>
      <el-table-column prop="certificationDesc" label="证书">
      </el-table-column>
      <el-table-column prop="specialty" label="特长">
      </el-table-column>
    </page-table>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created: function () {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// List.vue?03c9c4fe